import React from 'react';
import flow from 'lodash/flow';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import WidgetContainer from '~shared/ui/WidgetContainer';
import i18n from '~shared/utils/i18n';
import { getHasBoostedOddsSelections } from '~shared/utils/sportsbook';
import { showWidget } from '~shared/utils/widgets.js';
import { withLazyLoadContext } from '~spa/Components/LazyLoad/LazyLoad';
import * as popularWidgetActions from '../actions/popularWidgetActions';
import {
    COMPONENT_CLASS,
    POPULAR_EVENT_GTM_TAG,
    POPULAR_TITLE,
    POPULAR_TITLE_ICON_CLASS_NAME,
} from '../constants';
import EventCard from '~shared/components/react/EventCard';

const PopularWidgetContainer = ({
    events = [],
    getPopularWidgetEvents = Object.getPrototypeOf(Function),
    commonDataEvents = {},
    updateCommonStoreWsData = Object.getPrototypeOf(Function),
    stopListeningForUpdates = Object.getPrototypeOf(Function),
    source = '',
    lazyLoadHasLoaded = Object.getPrototypeOf(Function),
}) => {
    const wsEventListener = (wsData) => {
        updateCommonStoreWsData(wsData);
    };

    const refreshPopularWidget = async () => {
        await getPopularWidgetEvents(wsEventListener);
        lazyLoadHasLoaded();
    };

    useEffect(() => {
        refreshPopularWidget();

        return () => {
            stopListeningForUpdates();
        };
    }, []);

    const createEventTemplate = (event) => {
        const {
            id,
            name,
        } = event;
        const gtm = `${source};${POPULAR_EVENT_GTM_TAG};${name}`;

        return (
            <EventCard
                key={id}
                event={event}
                gtm={gtm}
            />

        );
    };

    return (
        <div className={COMPONENT_CLASS}>
            {showWidget(events, commonDataEvents) && (
                <WidgetContainer
                    title={i18n.t(POPULAR_TITLE)}
                    titleIconClassName={POPULAR_TITLE_ICON_CLASS_NAME}
                >
                    {events.map((event) => {
                        const { event_id: eventId, market_id: marketId } = event;
                        const eventObj = commonDataEvents[eventId];
                        if (!eventObj) {
                            return '';
                        }

                        const { selections } = eventObj.markets[marketId] || {};
                        const hasBoostedOddsSelections =
                            getHasBoostedOddsSelections(selections);

                        const updatedEvent = {
                            ...commonDataEvents[eventId],
                            hasBoostedOddsSelections,
                        };

                        return createEventTemplate(updatedEvent);
                    })}
                </WidgetContainer>
            )}
        </div>
    );
};

PopularWidgetContainer.propTypes = {
    events: PropTypes.array,
    getPopularWidgetEvents: PropTypes.func,
    commonDataEvents: PropTypes.object,
    updateCommonStoreWsData: PropTypes.func,
    stopListeningForUpdates: PropTypes.func,
    source: PropTypes.string,
    lazyLoadHasLoaded: PropTypes.func,
};

/**
 * React-redux bindings
 * @param {*} state the current state
 * @returns {object} props
 */
function mapStateToProps(state) {
    return {
        events: state.popularWidget.events,
        commonDataEvents: state.commonData,
    };
}

/**
 * React-redux bindings
 * @param {*} dispatch the dispatcher function
 * @returns {object} betfeed actions
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(popularWidgetActions, dispatch);
}

export default flow(
    withLazyLoadContext(),
    connect(mapStateToProps, mapDispatchToProps)
)(PopularWidgetContainer);
